// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2vpXp","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1qe5U"};